import { useEffect, useState } from "react";

export const useDebounce = (value, delay = 500) => {
    const [debouncedValue, setDebouncedvalue] = useState(value);

    useEffect(() => {
        const timeout = setTimeout(() => {
            setDebouncedvalue(value);
        }, delay);

        return () => clearTimeout(timeout);
    }, [value, delay]);

    return debouncedValue;
}